import { Head } from "@inertiajs/react"
import type { ReactNode } from "react"

type AuthShellProps = {
  children: ReactNode
  heroDescription: string
  heroPoints: readonly string[]
  heroTitle: string
  pageTitle: string
}

export function AuthShell({
  children,
  heroDescription,
  heroPoints,
  heroTitle,
  pageTitle,
}: AuthShellProps) {
  return (
    <>
      <Head title={pageTitle} />
      <div className="min-h-screen bg-muted/30">
        <div className="mx-auto flex min-h-screen max-w-6xl flex-col justify-center gap-10 px-4 py-10 sm:px-6 lg:grid lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:px-8">
          <section className="hidden lg:block">
            <div className="inline-flex items-center rounded-full border bg-background/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-muted-foreground shadow-sm backdrop-blur">
              Innly
            </div>
            <h1 className="mt-6 max-w-xl text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
              {heroTitle}
            </h1>
            <p className="mt-4 max-w-xl text-base leading-7 text-muted-foreground sm:text-lg">
              {heroDescription}
            </p>
            <div className="mt-8 grid gap-3">
              {heroPoints.map((point, index) => (
                <div
                  className="flex items-start gap-3 rounded-2xl border bg-background/70 p-4 shadow-sm backdrop-blur"
                  key={index}
                >
                  <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">
                    •
                  </span>
                  <p className="text-sm leading-6 text-muted-foreground">{point}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mx-auto w-full max-w-md lg:mx-0 lg:justify-self-end">
            <div className="mb-6 flex justify-center lg:hidden">
              <div className="inline-flex items-center rounded-full border bg-background/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-muted-foreground shadow-sm">
                Innly
              </div>
            </div>
            {children}
          </section>
        </div>
      </div>
    </>
  )
}
